/* Scroll-reveal for Alchemy sections.

   Put [data-alchemy-reveal] on a container. Its direct children with a
   [data-reveal] attribute animate in when the container enters the viewport,
   staggered in DOM order. Values: up | left | right | fade | scale.

   Anything already on screen at load reveals immediately (no blank hero).
   Honours prefers-reduced-motion: everything is shown, nothing moves. */
(function () {
  if (window.alchemyRevealReady) return;
  window.alchemyRevealReady = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function play(container) {
    var items = container.querySelectorAll('[data-reveal]');
    var base = parseInt(container.dataset.alchemyRevealDelay, 10) || 0;
    var step = parseInt(container.dataset.alchemyRevealStagger, 10);
    if (isNaN(step)) step = 90;
    items.forEach(function (el, i) {
      el.style.transitionDelay = base + i * step + 'ms';
      el.classList.add('is-revealed');
    });
    container.classList.add('is-revealed');
  }

  function init(scope) {
    var root = scope || document;
    var containers = root.querySelectorAll('[data-alchemy-reveal]');

    if (reduce || !('IntersectionObserver' in window)) {
      containers.forEach(function (c) {
        c.classList.add('is-revealed');
        c.querySelectorAll('[data-reveal]').forEach(function (el) {
          el.classList.add('is-revealed');
        });
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries, obs) {
        entries.forEach(function (en) {
          if (en.isIntersecting) {
            play(en.target);
            obs.unobserve(en.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
    );

    containers.forEach(function (c) {
      if (c.dataset.alchemyRevealReady === 'true') return;
      c.dataset.alchemyRevealReady = 'true';
      // Already in view on load (e.g. the hero): reveal now, don't wait for scroll.
      var r = c.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) {
        play(c);
      } else {
        io.observe(c);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
  });
})();
